import { provideTransloco, TranslocoModule } from "@jsverse/transloco";
import { isDevMode, NgModule } from "@angular/core";
import { TranslocoHttpLoader } from "./transloco-loader";

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ["it", "en"],
        defaultLang: "it",
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
  ],
})
export class TranslocoRootModule {}
